var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "error-box" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-12 text-sm-center" },
        [
          _c("h1", [_vm._v("404")]),
          _vm._v(" "),
          _c("h5", [_vm._v("Whoops! You got Lost!")]),
          _vm._v(" "),
          _c(
            "router-link",
            { staticClass: "btn btn-lg bg-yellow", attrs: { to: "/" } },
            [
              _c("i", { staticClass: "icon-fa icon-fa-arrow-left" }),
              _vm._v(" Go Home\n      ")
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a5c70d3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a5c70d3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/errors/404.vue
// module id = 841
// module chunks = 0